/**
 * `@4f/frontend` error types. Every thrown error extends `AppError` (from
 * `@4f/shared`) so it carries a stable `code` — never a bare `Error`.
 */
import { AppError } from '@4f/shared';

/**
 * Thrown when the app cannot bootstrap because its DOM mount point is missing.
 * This is a programmer/deploy error (the `index.html` root node was removed),
 * so it fails loud at startup rather than silently rendering nothing.
 */
export class MountElementNotFoundError extends AppError {
  readonly code = 'mount_element_not_found';

  constructor(selector: string) {
    super(`Mount element "${selector}" was not found in the document.`);
  }
}

/**
 * Thrown when a `useRouter`/store hook runs outside its provider — a wiring bug
 * (the composition root forgot to wrap the tree). Fails loud in dev, never a
 * silent `undefined` context.
 */
export class MissingProviderError extends AppError {
  readonly code = 'missing_provider';

  constructor(hook: string, provider: string) {
    super(`\`${hook}\` must be used within a \`${provider}\`.`);
  }
}
